exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button {\n  float: left;\n  clear: both;\n  padding: 1em;\n  width: 100%;\n  text-align: center;\n  background: #2CC185;\n  border: 0;\n  color: white;\n  font-size: 1.1em;\n  cursor: pointer; }\n  .button:disabled {\n    background: grey;\n    cursor: default; }\n  .button.cancel {\n    background: #aaaaaa; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/ButtonComponent/button.component.scss
// module id = ./src/app/common/components/ButtonComponent/button.component.scss
// module chunks = main